import React from "react";
import "chart.js/auto";
import { Doughnut } from "react-chartjs-2";

const DoughnutChart = ({ data = { labels: [], datasets: [] }, options = {} }) => {
  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
